import { render, staticRenderFns } from "./FileAndFileTemplateDialog.vue?vue&type=template&id=f7df75ba&"
import script from "./FileAndFileTemplateDialog.vue?vue&type=script&lang=js&"
export * from "./FileAndFileTemplateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QDialog,QCard,QCardSection,QSpace,QBtn,QForm,QSelect,QChip,QInput,QToggle,QItem,QItemSection,QIcon,QItemLabel,QPopupProxy,QDate,QSeparator,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QDialog,QCard,QCardSection,QSpace,QBtn,QForm,QSelect,QChip,QInput,QToggle,QItem,QItemSection,QIcon,QItemLabel,QPopupProxy,QDate,QSeparator,QCardActions})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
